import React from "react";
import {
  BulletList,
  Heading,
  Link,
  List,
  ListItem,
  Text,
} from "../components/Text/Text";
import { LIMIT } from "styled-components/dist/utils/createWarnTooManyClasses";

const PrivacyPolicyPage = () => {
  return (
    <>
      <Heading>Tko smo mi?</Heading>
      <Text>
        Mi smo Pučko otvoreno učilište Križevci, Trg sv. Florijana 14, 48260
        Križevci, (u daljnjem tekstu „POU Križevci“) Možete nas kontaktirati
        putem e-maila kino@pou-krizevci.hr, putem pošte na gore navedenu adresu
        ili telefonskim pozivom na 048/711-212
      </Text>
      <Heading>Što obuhvaća ova izjava o sigurnosti i privatnosti</Heading>
      <Text>
        Ova Izjava se odnosi na našu web stranicu https://kino.krizevci.hr i
        ostale usluge koje pružamo ( u daljnjem tekstu „Servisi“). Izjava o
        sigurnosti i privatnosti se odnosi na osobne podatke i općenite podatke
        koje prikupljamo od Vas dok koristite Servise. Poštujemo Vaše pravo na
        privatnost i obrađujemo samo osobne podatke u skladu s odgovarajućim
        odredbama zaštite privatnosti u Europskoj uniji i van nje. POU Križevci
        surađuje s pouzdanim partnerima poput Jetpack od WordPress.com za
        analitičke alate (u daljnjem tekstu “Partneri”). Za osobne podatke
        obuhvaćene ovom Izjavom o privatnosti koju koristi web stranica, POU
        Križevci je voditelj obrade (eng. data controller) pod Općom uredbom o
        zaštiti osobnih podataka (GDPR).
      </Text>
      <Heading>Podaci koje prikupljamo</Heading>
      <Text>
        Dok koristite naše web stranice možemo prikupljati tehničke podatke o
        uređajima s kojima pristupate našoj stranici (npr. tip preglednika (eng.
        browsera)), te Vaše ime i prezime kao i adresu e-pošte u svrhu
        rezervacije karata. Sve gore navedeni podaci su podaci naših korisnika i
        ne odaju osobne podatke.
      </Text>
      <Heading>Kolačići (eng. cookies)</Heading>
      <Text>
        Upotrebljavamo kolačiće kako bi o Vama prikupljala informacije i
        pohranila Vaše odabrane postavke na mreži. Kolačići su tekstualne
        datoteke koje sadrže male količine informacija koje se preuzimaju na Vaš
        uređaj kada posjetite internetsku stranicu. Kada stranicu ponovno
        posjetite, kolačići se vraćaju pripadajućoj internetskoj stranici: to je
        korisno jer takvoj internetskoj stranici omogućuje da prepozna Vaš
        uređaj. Za više informacija o kolačićima, posjetite
        www.allaboutcookies.org Upotrebljavamo slijedeće kategorije kolačića na
        stranici: Kategorija 1: Strogo neophodni kolačići (eng. session cookies)
        Ovi su kolačići nužni kako bi Vam omogućili kretanje po Stranici i
        uporabu njezinih značajki. Bez tih kolačića ne mogu Vam se pružiti
        usluge koje ste zatražili. Kategorija 2: Funkcionalni kolačići (eng.
        persistent cookies) Ovi kolačići pamte Vaše odabire. Takvi se podaci
        potom mogu upotrijebiti kako bi Vam se osiguralo iskustvo koje je
        prikladnije Vašim odabirima i posjećivanje stranice koje je
        prilagođenije Vašim potrebama i navikama. Informacije koje prikupljaju
        ovi kolačići mogu biti u anonimnom obliku i ovi kolačići ne mogu pratiti
        Vašu aktivnost pregledavanja na drugim internetskim stranicama.
        Kategorija 3: Kolačići trećih strana Jetpack cookies – servis za analizu
        posjeta stranici i unaprjeđenje sadržaja Ovi kolačići prikupljaju
        informacije o tome kako se ljudi koriste stranicom. Primjerice, mi
        upotrebljavamo ove kolačiće kako bi nam pomogli razumjeti kako korisnici
        dolaze na stranicu, pregledavaju ili upotrebljavaju Stranicu te kako bi
        nam istaknuli pojedinosti koje možemo poboljšati kao što su navigacija i
        korisničko iskustvo. Ovi kolačići sve informacije prikupljaju zbirno i
        stoga su takve informacije anonimne. Ako želite izbrisati bilo koje
        kolačiće koji su već na Vašem računalu, na internetskom pregledniku, u
        dijelu vezanom uz pomoć i podršku, potražite upute za pronalaženje
        datoteke ili direktorija koji pohranjuje kolačiće. Imajte na umu da
        brisanjem kolačića (ili onemogućavanjem budućih kolačića) možda nećete
        moći pristupiti određenim dijelovima ili značajkama stranice. Kako
        koristimo Vaše podatke? Vaše podatke obrađujemo isključivo kako bi mogli
        ispuniti uslugu servisa koji ste koristili ili iz drugih razloga koji su
        bitni da Vas držimo obaviještenim/om kako bismo Vas zaštitili od
        prijevare.
      </Text>
      <Heading>Kako upravljamo Vašim podacima</Heading>
      <Text>
        Podaci koje unosite putem web stranice smješteni su na serveru kojem
        samo mi kao vlasnici imamo pristup. Na serveru se redovito provode mjere
        zaštite osobnih podataka protiv neovlaštenog ili nezakonitog postupanja,
        slučajnog gubitka uništavanja ili oštećenja. Server se nalazi smješten u
        vrhunski osiguranim centrima s podacima te s kontrolom pristupa i
        sigurnosnim sustavima. Vaši podaci se pohranjuju dokle god koristite
        naše servise.
      </Text>
      <Heading>Kako koristimo Vaše podatke?</Heading>
      <Text>Prikupljene podatke koristimo na slijedeće načine:</Text>
      <List>
        <ListItem>
          da bismo ispunili naše obveze u pružanju korištenja servisa
        </ListItem>
        <ListItem>
          da bismo osigurali učinkovit rad servisa za računalo ili neki drugi
          uređaj s kojega pristupate
        </ListItem>
        <ListItem>
          kako bismo procijenili učinkovitost naših marketinških aktivnosti i
          poboljšali kvalitetu našeg marketinga
        </ListItem>
        <ListItem>
          za svrhu odgovornosti definirane zakonodavstvom Europske unije (GDPR)
        </ListItem>
      </List>
      <Heading>Dijeljenje podataka</Heading>
      <Text>
        Vaše podatke ne dijelimo s trećim stranama. Postoje iznimke, u slučaju
        naših Partnera, kada dijelimo najosnovnije potrebne podatke s ciljem da
        nam pomognu u ispunjenju naših obveza prema Vama. Partneri stoga mogu
        imati potencijalni ili pravi pristup ograničenim podacima o Vama i
        obrađivati ih u naše ime. Službeni naziv im je izvršitelji obrade (eng.
        data processors): dobavljači analitičkih alata (Jetpack). Vaši podaci
        mogu biti obrađivani, pohranjeni i preneseni van zemlje prebivališta i
        to u Sjedinjene Američke Države. Zakoni o privatnosti u toj državi možda
        nemaju jednak nivo zaštite kao u Vašoj državi ili Europskoj uniji. Kada
        god dijelimo Vaše osobne podatke van Europske unije, to činimo uz
        zakonski važeće mjere koje nam omogućuju prijenos Vaših podataka i
        ostvarivanje njihove adekvatne zaštite.
      </Text>
      <Heading>Ostalo</Heading>
      <Text>
        Poveznice Kada kliknete veze na našoj web stranici, oni vas mogu
        usmjeriti s naše web stranice. Nismo odgovorni za praksu privatnosti
        drugih web mjesta i potičemo Vas da pročitate njihove izjave o
        privatnosti.
      </Text>
      <Heading>Izmjene ove Izjave o sigurnosti i privatnosti</Heading>
      <Text>
        Zadržavamo pravo izmjene ove Izjave o sigurnosti i privatnosti ukoliko
        smatramo da je to potrebno iz pravnih razloga. U tom slučaju ćemo
        objaviti izmjene na našoj web stranici. Također, ažurirati ćemo sekciju
        “Zadnja izmjena”. Nakon što promijenimo Izjavu o sigurnosti i
        privatnosti, ona postaje pravomoćna odmah nakon objave. Ukoliko se ne
        slažete s tim izmjenama molimo Vas da prestanete koristiti naše servise.
      </Text>
      <Heading>PITANJA I KONTAKT PODACI</Heading>
      <Text>
        Ako želite zatražiti dodatne informacije, obratite se našem službeniku
        za poštivanje privatnosti na{" "}
        <Link href="mailto:kino@pou-krizevci.hr">kino@pou-krizevci.hr</Link>
      </Text>
      <Heading>UVJETI KORIŠTENJA</Heading>
      <Text>
        Uvjeti korištenja web domene{" "}
        <Link href="https://kino.krizevci.hr" target="_blank">
          https://kino.krizevci.hr
        </Link>{" "}
        i njenih podstranica Internetska stranica{" "}
        <Link href="https://kino.krizevci.hr" target="_blank">
          https://kino.krizevci.hr
        </Link>{" "}
        u vlasništvu je Grada Križevaca koji omogućava korištenje usluga i
        sadržaja internetske stranice{" "}
        <Link href="https://kino.krizevci.hr" target="_blank">
          https://kino.krizevci.hr
        </Link>{" "}
        regulirana je ovim Uvjetima korištenja (dalje u tekstu: Uvjeti).
        Korištenjem web stranice
        <Link href="https://kino.krizevci.hr" target="_blank">
          https://kino.krizevci.hr
        </Link>{" "}
        i svih pridruženih stranica i servisa koji pripadaju domeni{" "}
        <Link href="https://kino.krizevci.hr" target="_blank">
          https://kino.krizevci.hr
        </Link>{" "}
        (dalje u tekstu: Kino Križevci) smatra se da su korisnici u svakom
        trenutku upoznati s ovim Uvjetima te da ih u cijelosti razumiju i
        prihvaćaju. U slučaju pristupa i/ili korištenja domene{" "}
        <Link href="https://kino.krizevci.hr" target="_blank">
          https://kino.krizevci.hr
        </Link>{" "}
        i svih povezanih poddomena te pripadajućeg sadržaja (primjerice:
        fotografije, tekst, grafike, ilustracije i podaci), aplikacija, softvera
        i usluga koje se omogućavaju putem web stranice Kino Križevci bez obzira
        na način korištenja, korisnik izričito pristaje bez ikakvih ograničenja
        ili rezervi na korištenje i uporabu web stranice Kino Križevci u skladu
        s ovim Uvjetima, a reguliranje svih pravnih odnosa koji proizlaze ili
        mogu proizaći iz korištenja/uporabe web stranice Kino Križevci vrši se u
        skladu s ovim Uvjetima. Korisnici su dužni redovito provjeravati Uvjete
        te se smatra da su korisnici korištenjem web stranice Kino Križevci ili
        bilo kojeg njenog dijela, u svakom trenutku upoznati s aktualnim
        Uvjetima korištenja te da su ih razumjeli i prihvatili u cijelosti.
        Korisnici sami snose odgovornost za posljedice nepostupanja u skladu s
        ovom odredbom Uvjeta. POU Križevci pridržava pravo izmjene ovih Uvjeta u
        svako doba bez obaveze prethodne najave te neće biti odgovoran ni za
        kakve moguće posljedice proizašle iz takvih promjena. Navedene promjene
        stupaju na snagu objavljivanjem na ovim internet stranicama. POU
        Križevci pridržava pravo promjene sadržaja kao i svih servisa i
        podstranica koje su sastavni dio web stranice Kino Križevci, bez obaveze
        prethodne najave te neće biti odgovoran ni za kakve moguće posljedice
        proizašle iz takvih promjena. Navedene promjene stupaju na snagu
        objavljivanjem na ovim internetskim stranicama. POU Križevci pridržava
        pravo promjene, ograničenja ili prestanak pružanja usluge web stranice
        Kino Križevci u svako doba bez obaveze prethodne najave, uključivo i
        djelomično ili u potpunosti ograničiti pristup web stranice Kino
        Križevci te pružanju određenih usluga u slučaju kršenja odredbi ovih
        Uvjeta. POU Križevci nije odgovoran za bilo koji oblik štete koja na
        bilo koji način može nastati iz, ili je na bilo koji način vezana za
        korištenje web stranice Kino Križevci te za bilo kakvu štetu koja može
        nastati korisniku/posjetitelju ili bilo kojoj trećoj strani u vezi s
        uporabom ili zlouporabom korištenja sadržaja web stranice Kino Križevci.
        Korištenjem sadržaja web stranice Kino Križevci, korisnik prihvaća sve
        rizike koji nastaju iz takvog korištenja.
      </Text>
      <Heading>SADRŽAJ, USLUGE I APLIKACIJE</Heading>
      <Text>
        Sav sadržaj koji se prikazuje ili nalazi na web stranicama Kino
        Križevci, uključujući objavljeni tekst, grafike, ilustracije,
        fotografije, dokumente, podatke i informacije, ne smiju se
        reproducirati, distribuirati ili na bilo koji način koristiti na način
        koji je protivan ovim Uvjetima. Posebno je zabranjeno kopirati,
        mijenjati, objavljivati, prenositi, prodavati, prikazivati ili na bilo
        koji drugi način iskorištavati sadržaj i vizualni identitet Kina
        Križevci, osim kada je takva mogućnost predviđena ovim Uvjetima ili je
        rezultat prethodnog odobrenja Kina Križevci. Pohrana ili kopiranje
        sadržaja za bilo koju svrhu i na bilo koji način i korištenje je
        zabranjena. U slučaju neovlaštenog, nedopuštenog i/ili protuzakonitog
        korištenja bilo kojeg sadržaja (tekst, fotografije itd.) web stranice
        Kina Križevci, POU Križevci pravo potraživati naknadu štete i pokrenuti
        građanski i kazneni postupak protiv pravne ili fizičke osobe koja na
        opisani način koristi sadržaje web stranice Kino Križevci.
      </Text>
      <Heading>
        KORIŠTENJE STRANICE{" "}
        <Link href="https://kino.krizevci.hr" target="_blank">
          HTTPS://KINO.KRIZEVCI.HR
        </Link>{" "}
        I NJOJ PRIDRUŽENIH STRANICA
      </Heading>
      <Text>
        Zabranjeno je korištenje stranica i sadržaja za bilo koju svrhu koja
        nije u skladu s ovim Uvjetima. Korisnik potvrđuje i jamči da će ove
        stranice koristiti u skladu s ovim Uvjetima i svim primjenjivim zakonima
        i pravilima, uključujući, bez ograničenja, sve one koje se odnose na
        internet, e-mail (poruke elektroničke pošte), podatke i privatnost.
        Korisnik stranica potvrđuje i jamči da će preuzeti sadržaj koristiti
        isključivo na način u skladu s ovim Uvjetima, u protivnom takvo
        korištenje smatra se nedopuštenim, u kojem slučaju je POU Križevci
        ovlašten potraživati naknadu štete od korisnika te mu u cijelosti ili
        djelomično ograničiti pružanje usluge. POU Križevci zadržava pravo
        sprječavanje pristupa web stranicama s IP adresa korisnika s kojih se
        vrše radnje protivne ovim Uvjetima korištenja, te s te osnove POU
        Križevci neće snositi nikakvu odgovornost.
      </Text>
      <Heading>Opći uvjeti poslovanja</Heading>
      <Text>
        Molimo Vas da se prije donošenja odluke o korištenju usluga javnog
        prikazivanja audiovizualnih djela i drugih usluga koje se s vremena na
        vrijeme pružaju u Kinu Križevci (“usluga”), odnosno rezervacije,
        naručivanja i plaćanja usluge (pružatelj usluga društvo Pučko otvoreno
        učilište Križevci (u daljnjem tekstu POU Križevci)), Trg sv. Florijana
        14, 48260 Križevci i/ili općenito ulaska u prostorije Kina Križevci,
        upoznate s ovim Općim uvjetima poslovanja Kina Križevci. Imate li bilo
        kakvih pitanja ili nejasnoća vezanih za uvjete poslovanja, molimo da nam
        se obratite na e-mail adresu:{" "}
        <Link href="mailto:kino@pou-krizevci.hr">kino@pou-krizevci.hr</Link>,
        putem pošte na gore navedenu adresu ili telefonskim pozivom na
        048/711-212.
      </Text>
      <Heading>Prihvaćanje Općih uvjeta</Heading>
      <List>
        <ListItem>
          Korištenjem i/ili rezervacijom i/ili narudžbom usluge i/ili kupnjom
          ili drugim stjecanjem kinoulaznice za korištenje usluga (uključujući
          sve dostupne prodajne kanale) i/ili ulaskom u prostorije Kina
          Križevci, prihvaćate ove Opće uvjete poslovanja POU Križevci (“Opći
          uvjeti poslovanja”), kao i sva ostala pravila i uvjete korištenja
          usluga POU Križevci koja se primjenjuju u trenutku korištenja istih.
          Ukoliko se ne slažete s navedenim, molimo Vas nemojte koristiti,
          rezervirati, naručivati usluge, odnosno kupovati ili na drugi način
          stjecati ulaznice za korištenje usluga te ne ulazite u prostorije Kina
          Križevci.
        </ListItem>
        <ListItem>
          Na sva ostala pitanja vezana uz usluge, plaćanje kao i općenito uz
          korištenje Kina Križevci primjenjuju se važeća pravila u trenutku
          korištenja istih.
        </ListItem>
        <ListItem>
          U slučaju prenošenja ulaznice sa kupca na treću osobu, ovi Opći uvjeti
          se prenose i primjenjuju na svakodobnog imatelja odnosne kinoulaznice,
          kao i na osobu koja u odnosnom trenutku koristi, rezervira, naručuje,
          kupuje ili stječe uslugu, odnosno nalazi se u prostorijama Kina
          Križevci. Kupac je obvezan ukazati osobi kojoj prenosi kinoulaznicu na
          odredbe ovih Općih uvjeta.
        </ListItem>
      </List>
      <Heading>Promjene Općih uvjeta i stupanje na snagu</Heading>
      <List start={4}>
        <ListItem>
          POU Križevci zadržava pravo u bilo kojem trenutku izmijeniti i/ili
          dopuniti ove Opće uvjete te takve promjene stupaju na snagu danom
          objave. Nastavljanjem korištenja usluge nakon promjene Općih uvjeta
          smatrat će se da pristajete na takve izmijenjene ili dopunjene Opće
          uvjete. POU Križevci Vam savjetuje da prije korištenja, rezervacije,
          narudžbe, kupnje ili drugog stjecanja kinoulaznice za korištenje
          usluga ili ulaska u prostorije Kina Križevci provjerite ove Opće
          uvjete kako bi bili upoznati sa eventualnim promjenama istih.
        </ListItem>
      </List>
      <Heading>Rezervacija i kupnja ulaznica</Heading>
      <List start={5}>
        <ListItem>
          Kupnja kinoulaznica moguća je do početka projekcije. Rezervacije se
          brišu 30 minuta prije početka projekcije, osim u slučaju posebnih
          akcija. U tom slučaju, informacije o brisanju rezervacija biti će
          posebno istaknute na stranici akcije i u procesu rezervacije ulaznica.
          Sve nepreuzete rezervacije sustav će automatski obrisati.
        </ListItem>
        <ListItem>Kupnjakinoulaznica je moguća za sva sjedala.</ListItem>
        <ListItem>
          Ukupan broj mjesta koja je moguće kupiti online je ograničen. Ukoliko
          sustav ne dozvoljava kupnju zbog popunjenosti, kinoulaznice je još
          uvijek moguće kupiti na blagajnama.
        </ListItem>
        <ListItem>Ulaznice moguće je kupiti online, na blagajni kina.</ListItem>
        <ListItem>
          POU Križevcizadržava pravo u svako doba ograničiti ili onemogućiti
          mogućnost rezervacije za pojedine projekcije i/ili usluge i/ili
          dvorane i/ili pojedine zone unutar dvorane i/ili pojedina kina i/ili
          za određena specifična razdoblja.
        </ListItem>
        <ListItem>
          Kinoulaznice je moguće kupiti na blagajnama POU Križevci ili online.
        </ListItem>
        <ListItem>
          Postupak online kupnje kinoulaznica (web stranica ) uređen je sukladno
          Općim uvjetima plaćanja putem Interneta koji su dostupni ovdje.
        </ListItem>
        <ListItem>
          Kinolaznice je moguće platiti gotovinom ili bankovnim karticama.
        </ListItem>
        <ListItem>
          Djeca plaćaju punu cijenu kinoulaznice bez obzira na dob.
        </ListItem>
        <ListItem>
          Za kupnju kinoulaznice vrijede cijene navedene za određenu projekciju
          odnosno uslugu navedene na cjeniku kinoulaznica koji je dostupan na
          web stranici i na blagajni kina. U cijenu kinoulaznice nije uračunat
          PDV. Cijene proizvoda su podložne promjenama do trenutka početka
          kupovine ili rezervacije ulaznica o kojoj promjeni će POU Križevci
          obavijestiti kupca na jasan i razumljiv način.
        </ListItem>
        <ListItem>
          Prilikom kupovine kinoulaznica gotovinom, kupac je dužan na licu
          mjesta prebrojiti vraćeni novac jer naknadne reklamacije ne uvažavamo.
          POU Križevci zadržava pravo izmjene cjenika.
        </ListItem>
        <ListItem>
          Posjetitelj se obvezuje odmah nakon preuzimanja kinoulaznice
          provjeriti podatke o željenoj usluzi, vremenu i mjestu projekcije, te
          sve ostale podatke jer naknadne reklamacije neće biti uvažene.
        </ListItem>
        <ListItem>
          Storniranje kupljenih ulaznica ili usluge nije moguće. Zamjena
          kupljene ulaznice ili usluge za drugu uslugu je moguća najkasnije sat
          vremena prije početka projekcije za koju je kinoulaznica kupljena,
          isključivo na blagajni kina za koje je kinoulaznica kupljena, osim u
          slučaju posebnih akcija (1+1 gratis, ulaznice kupljene po akcijskoj
          cijeni…), za istu projekciju zbog promjene mjesta sjedenja te
          kinoulaznica kupljenih u pretprodaji za koje nije moguća zamjena niti
          povrat sredstava. Pretprodaja podrazumijeva da su ulaznice puštene u
          prodaju tjedan ili više dana prije datuma prikazivanja nekog filma.
        </ListItem>
        <ListItem>
          Kupac nema pravo na naknadu za neiskorištenu ili djelomično
          iskorištenu (zbog zakašnjenja) ili za izgubljenu kinoulaznicu.
        </ListItem>
        <ListItem>
          Za kupljene, a nepreuzete kinoulaznice nije moguće tražiti povrat
          sredstava (novca, bonus ulaznica, bodova…).
        </ListItem>
      </List>
      <Heading>Blagajne</Heading>
      <List start={20}>
        <ListItem>
          Za radno vrijeme blagajni za prodaju kinoulaznica informirajte se na
          stranici POU Križevci.
        </ListItem>
        <ListItem>
          Blagajne za prodaju kinoulaznica zatvaraju se pola sata nakon početka
          posljednje projekcije.
        </ListItem>
      </List>
      <Heading>Ulazak u dvorane</Heading>
      <List start={22}>
        <ListItem>
          Pravo na ulazak u dvoranu stječe se pokazivanjem važeće kinoulaznice,
          odnosno, potvrde.
        </ListItem>
        <ListItem>
          Zabranjen je ulazak u dvoranu bez važeće kinoulaznice. POU Križevci
          zadržava pravo provjeriti pravo ulaska kao i osnovu za ostvarenje
          popusta te u slučaju nedostatka spomenutog posjetitelju zabraniti
          ulazak u dvoranu, tj. posjetitelja udaljiti iz nje. Iz tog razloga je
          posjetitelj dužan kod sebe imati kinoulaznicu i dokaz o pravu na
          stjecanje popusta (npr. studentska iskaznica i sl.) do kraja
          projekcije.
        </ListItem>
        <ListItem>
          Posjetiteljima koji žele ući u dvoranu nakon početka projekcije ulazak
          će biti dozvoljen prema diskrecijskoj ocjeni osoblja POU Križevci,
          samo ako se time ne ometaju drugi posjetitelji.
        </ListItem>
        <ListItem>
          Unošenje oružja, digitalnih foto aparata i sličnih uređaja za snimanje
          slike ili zvuka nije dozvoljeno.
        </ListItem>
        <ListItem>
          U dvorane je dopušteno unositi samo hranu i piće kupljene na prodajnim
          mjestima POU Križevci. POU Križevci zadržava pravo zabrane ulaska u
          dvoranu ukoliko posjetitelj sa sobom ima proizvode kupljene na drugome
          mjestu te ima pravo te proizvode zadržati do kraja projekcije te potom
          vratiti iste njihovom vlasniku.
        </ListItem>
        <ListItem>
          Uvođenje životinja (bilo koje vrste) u dvorane nije dozvoljeno, uz
          iznimku pasa vodiča za slijepe osobe i osobe s posebnim potrebama. Psi
          vodiči za slijepe osobe i osobe s posebnim potrebama mogu
          prisustvovati projekciji odnosno usluzi uz preduvjet da imaju brnjicu
          i da su na povodcu i uz pokaz iskaznice/putovnice kojom se dokazuje da
          je pas obučen za psa vodiča. Za njih se ne plaća naknada.
        </ListItem>
        <ListItem>
          U POU Križevci postoje dvorane s osiguranim mjestima za osobe s
          invaliditetom. Preporuča se prethodno provjeriti prilagođenost dvorane
          potrebama konkretnog posjetitelja.
        </ListItem>
      </List>
      <Heading>Ponašanje u prostorijama POU Križevci</Heading>
      <List start={29}>
        <ListItem>
          Posjetitelj je obvezan sjesti na sjedalo naznačeno na ulaznici te se
          pažljivo i odgovorno odnositi prema imovini i prostorijama POU
          Križevci.
        </ListItem>
        <ListItem>
          Nije dozvoljeno ometati ostale posjetitelje u praćenju projekcije.
        </ListItem>
        <ListItem>
          Na mobilnim telefonima treba isključiti zvuk, a upotreba bilo kakvog
          uređaja s mogućnošću snimanja slike ili tona za vrijeme projekcije
          nije dozvoljena.
        </ListItem>
        <ListItem>
          U unutrašnjim prostorijama POU Križevci nije dozvoljena upotreba
          koturaljki, inline koturaljki, skate boardova i sl.
        </ListItem>
        <ListItem>
          Osoblje POU Križevci nakon opominjanja može posjetitelje udaljiti s
          projekcije bez prava na povrat cijene ulaznice ukoliko:
          <BulletList>
            <ListItem>
              ne zauzmu mjesta koja su naznačena na njihovoj kinoulaznici
            </ListItem>
            <ListItem>
              svojim ponašanjem ometaju ostale posjetitelje tijekom prikazivanja
              filma
            </ListItem>
            <ListItem>
              su, prema mišljenju osoblja POU Križevci, pod utjecajem alkohola
              ili drugih opijata
            </ListItem>
            <ListItem>
              puše u prostorijama POU Križevci uključujući kinodvorane
            </ListItem>
            ž
            <ListItem>
              na pod bacaju ostatke hrane ili na bilo koji drugi način onečiste
              ili oštećuju prostorije ili imovinu
            </ListItem>
            <ListItem>
              u prostorije POU Križevci unesu oružje ili neke druge zakonom
              zabranjene predmete (opijate i sl.), i to neovisno o tome hoće li
              te predmete koristiti u kinodvorani ili ne
            </ListItem>
            <ListItem>
              bez dozvole osoblja POU Križevci u prostorije POU Križevci,
              uključujući kinodvorane, unesu hranu i/ili piće kupljenu izvan
              prostorija POU Križevci
            </ListItem>
          </BulletList>
        </ListItem>
        <ListItem>
          Po završetku usluge posjetitelji moraju napustiti kinodvoranu kroz
          označene izlaze. Nije dopušteno zadržavanje u kinodvorani nakon
          završetka prikazivanja.
        </ListItem>
        <ListItem>
          Po završetku projekcije posjetitelj je dužan vratiti 3D naočale
          osoblju kina (ukoliko je prisustvovao 3D projekciji).
        </ListItem>
        <ListItem>
          U prostorima POU Križevci zabranjena je upotreba elektronske cigarete
          (e-cigarete) i sličnih proizvoda.
        </ListItem>
        <ListItem>
          U prostorima POU Križevci posjetitelj se obvezuje poštivati propise
          vezane uz ograničavanje uporabe duhanskih proizvoda na snazi.
        </ListItem>
      </List>
      <Heading>Pravo izmjene dvorane i programa</Heading>
      <List start={38}>
        <ListItem>
          POU Križevci zadržava pravo promjene dvorane u kojoj će se održati
          projekcija za koju ste kupili kinoulaznice te vezano uz navedeno
          nemate pravo bilo kakvih potraživanja prema POU Križevci.
        </ListItem>
        <ListItem>
          POU Križevci zadržava pravo otkazivanja projekcije, kao i promjene u
          rasporedu ili terminu prikazivanja projekcija. U tim slučajevima, za
          kupljenu kinoulaznicu imate pravo tražiti povrat novca, uz obvezno
          predočenje računa o plaćenoj kinoulaznici za koju se traži povrat
          novca ili ju zamijeniti za istu projekciju u nekom drugom terminu.
        </ListItem>
      </List>
      <Heading>Odgovornost za stvari</Heading>
      <List start={40}>
        <ListItem>
          Posjetitelj je dužan paziti na osobne stvari i za čitavog trajanja
          projekcije držati ih kod sebe pod svojim nadzorom. POU Križevci ne
          odgovara ako su stvari nestale, uništene ili oštećene okolnostima koje
          se nisu mogle izbjeći ili otkloniti, uzrokom u stvari i zbog
          postupanja ili propusta samog posjetitelja.
        </ListItem>
        <ListItem>
          Preporučamo da sve vrijednije predmete ne unosite u prostorije POU
          Križevci, odnosno da organizirate njihovo čuvanje izvan prostorija POU
          Križevci. POU Križevci ne preuzima odgovornost za gubitak ili štetu na
          takvim predmetima.
        </ListItem>
        <ListItem>
          POU Križevci će, iznimno, na zahtjev posjetitelja primiti na čuvanje
          novac, dragocjenosti, vrijednosne papire i druge vrijedne stvari koje
          posjetitelj donese i hoće mu ih predati na čuvanje, osim ako utvrdi da
          u konkretnom slučaju ne raspolaže prikladnim prostorijama za njihov
          smještaj, ako su u odnosu na vrstu i kategoriju objekta od prekomjerne
          vrijednosti, ako su opasne, glomazne ili ako njihovo čuvanje prelazi
          mogućnosti POU Križevci iz kakva drugoga opravdanog razloga. Za sve
          takve stvari posjetitelj se obvezuje kontaktirati osoblje POU
          Križevci.
        </ListItem>
        <ListItem>
          POU Križevci ne preuzima odgovornost za izgubljene ili nestale stvari
          koje mu posjetitelj nije prethodno predao na čuvanje sukladno
          prethodnoj točki. Zabrana audio i video snimanja
        </ListItem>
        <ListItem>
          Audiovizualna djela i druga djela koja se prikazuju i koriste tijekom
          pružanja usluga su djela zaštićena autorskim pravom i drugim pravima
          intelektualnog vlasništva. Neovlaštena reprodukcija, distribucija,
          skladištenje, poduzimanje drugih radnji radi distribucije, javno
          prikazivanje ili stavljanje na raspolaganje javnosti takvih djela
          predstavlja kazneno djelo. Iz tog razloga nije dopušteno bilo kakvo
          snimanje uključujući tonsko i video snimanje tijekom prikazivanja
          filma (čak ni u privatne svrhe).
        </ListItem>
      </List>
      <Heading>Zaštita Vaših podataka</Heading>
      <List start={45}>
        <ListItem>
          Dok koristite naše web stranice možemo prikupljati tehničke podatke o
          uređajima s kojima pristupate našoj stranici (npr. tip preglednika
          (eng. browsera)), te Vaše ime i prezime kao i adresu e- pošte u svrhu
          rezervacije karata. Sve gore navedeni podaci su podaci naših korisnika
          i ne odaju osobne podatke.
        </ListItem>
        <ListItem>
          Podaci koje unosite putem web stranice smješteni su na serveru kojem
          samo mi kao vlasnici imamo pristup. Na serveru se redovito provode
          mjere zaštite osobnih podataka protiv neovlaštenog ili nezakonitog
          postupanja, slučajnog gubitka uništavanja ili oštećenja. Server se
          nalazi smješten u vrhunski osiguranim centrima s podacima te s
          kontrolom pristupa i sigurnosnim sustavima.Vaši podaci se pohranjuju
          dokle god koristite naše servise.
        </ListItem>
        <ListItem>
          Vaše podatke ne dijelimo s trećim stranama. Postoje iznimke, u slučaju
          naših Partnera, kada dijelimo najosnovnije potrebne podatke s ciljem
          da nam pomognu u ispunjenju naših obveza prema Vama. Partneri stoga
          mogu imati potencijalni ili pravi pristup ograničenim podacima o Vama
          i obrađivati ih u naše ime. Službeni naziv im je izvršitelji obrade
          (eng. data processors): dobavljači analitičkih alata (Jetpack).
        </ListItem>
        <ListItem>
          Vaši podaci mogu biti obrađivani, pohranjeni i preneseni van zemlje
          prebivališta i to u Sjedinjene Američke Države. Zakoni o privatnosti u
          toj državi možda nemaju jednak nivo zaštite kao u Vašoj državi ili
          Europskoj uniji. Kada god dijelimo Vaše osobne podatke van Europske
          unije, to činimo uz zakonski važeće mjere koje nam omogućuju prijenos
          Vaših podataka i ostvarivanje njihove adekvatne zaštite.
        </ListItem>
        <ListItem>
          Svi podaci o korisničkoj kartici su šifrirani GeoTrust EV SSL
          certifikatom, radi maksimalne sigurnosti i zaštite podataka.
        </ListItem>
        <ListItem>
          Kako bi zaštita Vaših podataka bila potpunija, povjerljive informacije
          o karticama (broj kartice, datum važenja i CVV kod) koje ste naveli se
          ne pohranjuju na serveru POU Križevci. CorvusPay sustav može spremiti
          informacije o Vašoj bankovnoj kartici, ukoliko odaberete spremanje
          podataka na platnoj stranici. U tom slučaju, prilikom idućeg online
          plaćanja nije potrebno ponovno upisivati podatke bankovne kartice.
        </ListItem>
        <ListItem>
          Transakcijom putem Vaše kartice upravlja treća strana (CorvusPay) koja
          zaprima broj kreditne kartice i ostale osobne podatke isključivo za
          identifikaciju i odobrenje transakcije. CorvusPay osigurava potpunu
          tajnost Vaših kartičnih i osobnih podataka već od trenutka kada ih
          upišete u CorvusPay platni formular. Platni podaci se prosljeđuju
          šifrirano od Vašeg web preglednika do banke koja je izdala Vašu
          karticu. POU Križevci nikada ne dolazi u kontakt s cjelovitim podacima
          o Vašoj platnoj kartici. Također, podaci su nedostupni čak i
          djelatnicima CorvusPay-a.
        </ListItem>
        <ListItem>
          CorvusPay sve prikupljene podatke smatra tajnom i tretira ih u skladu
          sa tim. Svi podaci se koriste isključivo u svrhe za koje su
          namijenjene. Vaši podaci su u potpunosti sigurni, a njihova privatnost
          je zajamčena najmodernijim zaštitinim mehanizmom. Također, CorvusPay
          se brine o sigurnosti Vaših podataka prilikom autorizacije kreditnih
          kartica. Prijenos podataka osiguran je korištenjem TLS sigurnosnog
          protokola. POU Križevci ne odgovara za slučaj neovlaštenog korištenja
          Vaših osobnih podataka i/ili broja kreditne kartice.
        </ListItem>
      </List>
      <Heading>Prigovori</Heading>
      <List start={53}>
        <ListItem>
          Svi prigovori mogu se predati u poslovnim prostorijama POU Križevci
          kao i slati u pisanom obliku na slijedeću adresu: Pučko otvoreno
          učilište Križevci Kino Križevci Trg sv. Florijana 14, 48260 Križevci
          POU Križevci će se očitovati na Vaš prigovor u roku od 15 dana od dana
          zaprimanja prigovora.
        </ListItem>
      </List>
      <Heading>Ograničenje odgovornosti</Heading>
      <List start={54}>
        <ListItem>
          Usluge POU Križevci koristite isključivo na Vašu vlastitu odgovornost.
          POU Križevci ne odgovara za sadržaj usluge, odnosno sadržaja koji se
          prikazuje na projekcijama
        </ListItem>
        <ListItem>
          POU Križevci ne odgovara ni za kakvu štetu koja bi mogla nastati zbog
          postupanja posjetitelja ili trećih osoba protivno odredbama ovih Općih
          uvjeta.
        </ListItem>
        <ListItem>
          POU Križevci odgovara isključivo za štetu nastalu zbog namjere ili
          krajnje nepažnje.
        </ListItem>
      </List>
      <Heading>Opće odredbe</Heading>
      <List start={57}>
        <ListItem>
          Na odnos između Vas i POU Križevci primjenjuju se pozitivni propisi
          Republike Hrvatske. U slučaju spora nadležan je stvarno nadležni sud u
          Zagrebu.
        </ListItem>
        <ListItem>
          U slučaju spora između potrošača i POU Križevci, potrošač može
          podnijeti i prijavu Sudu časti Hrvatske gospodarske komore, Zagreb,
          Rooseveltov trg 2, link:{" "}
          <Link
            href="https://www.hgk.hr/sud-casti-pri-hgk/o-sudu-casti"
            target="_blank"
          >
            https://www.hgk.hr/sud-casti-pri-hgk/o-sudu-casti
          </Link>
        </ListItem>
        <ListItem>
          Povrh navedenog, potrošač, koji je rezident jedne od država članica
          Europske Unije, može pokrenuti postupak koristeći Online platformu za
          rješavanje potrošačkih sporova Europske Unije u slučaju ugovora
          sklopljenih na daljinu (online). Online platformi EU može se
          pristupiti putem poveznice:{" "}
          <Link href="http://ec.europa.eu/odr." target="_blank">
            http://ec.europa.eu/odr.
          </Link>
        </ListItem>
      </List>
    </>
  );
};

export default PrivacyPolicyPage;
